import {
  APP_ZONES,
  PermissionConfig,
  WorkflowConfig,
  WorkflowPageConfig,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_164ToV1_0_165 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.165';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        roles.forEach((item) => {
          const paymentZone = item.zones[APP_ZONES.PAYMENT];
          if (paymentZone) {
            const mobilePages = paymentZone?.canvases?.subscription?.['default']?.mobile?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const desktopPages = paymentZone?.canvases?.subscription?.['default']?.desktop?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const tabletPages = paymentZone?.canvases?.subscription?.['default']?.tablet?.pages as
              | WorkflowPageConfig[]
              | undefined;
            if (mobilePages?.length) {
              removeSmsPages(mobilePages);
            }
            if (desktopPages?.length) {
              removeSmsPages(desktopPages);
            }
            if (tabletPages?.length) {
              removeSmsPages(tabletPages);
            }
          }
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
        };
      },
    },
  };
};

/**
 * Removes the static SMS Auth pages from the workflow config.
 * These are now redundant as the SMS Auth pages are now handled by the new Confirmation Auth flow.
 *
 * Currently targets:
 * - 'bulk-payment-authentication-sms'
 * - 'intl-authentication-sms'
 * - 'authentication-sms'
 */
const removeSmsPages = (pagesArray: WorkflowPageConfig[]): WorkflowPageConfig[] => {
  /**
   * Finds a page that has a name that matches one of the SMS pages.
   *
   */
  const bulkPaymentSmsPage = 'bulk-payment-authentication-sms';
  const intlPaymentSmsPage = 'intl-authentication-sms';
  const domesticPaymentSmsPage = 'authentication-sms';
  // Filter out pages with names matching the specified SMS page names
  for (let i = pagesArray.length - 1; i >= 0; i--) {
    if ([bulkPaymentSmsPage, intlPaymentSmsPage, domesticPaymentSmsPage].includes(pagesArray[i]?.name)) {
      pagesArray.splice(i, 1);
    }
  }

  return pagesArray;
};
